function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.59.59L6 5.17 1.41.59 0 2l6 6 6-6z",
  fill: "currentColor"
});

function SvgIconChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 8"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTAuNTkuNTktNC41OSA0LjU4LTQuNTktNC41OC0xLjQxIDEuNDEgNiA2IDYtNnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";
export { SvgIconChevronDown as ReactComponent };